var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.852v-6.164c0-.352-.188-.68-.445-.89-.586-.446-1.055-.82-3.844-2.836C13.312 6.68 12.539 5.977 12 6c-.563-.024-1.336.68-1.734.96-2.79 2.016-3.258 2.391-3.844 2.836a1.159 1.159 0 0 0-.422.891v6.164a1.11 1.11 0 0 0 1.125 1.125h9.75c.61 0 1.125-.492 1.125-1.125zm-1.547-4.594.211.305c.023.023.023.07.023.117s-.023.117-.07.14c-.539.4-1.289.962-2.46 1.806-.493.351-1.337 1.125-2.157 1.101-.844.024-1.688-.75-2.18-1.101-1.172-.844-1.922-1.407-2.46-1.805-.048-.024-.07-.094-.07-.14 0-.048 0-.095.022-.118l.211-.305c.07-.093.188-.117.282-.046.515.398 1.289.96 2.46 1.804.4.281 1.172.985 1.735.961.54.024 1.313-.68 1.71-.96a103.449 103.449 0 0 0 2.462-1.806c.094-.07.21-.046.281.047z",
    fill: "#1E2B3B",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.e3325ee2d679dd9669b9a62fbc7f4e94.svg";
export { ForwardRef as ReactComponent };